import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Colors } from '../../Themes'

import AntButton from 'antd/lib/button'
require('antd/lib/button/style')

const fontSizes = {
  large: 13,
  medium: 12,
  default: 12,
  small: 10
}
const sizes = {
  large: 1.6,
  medium: 1.5,
  default: 1.5,
  small: 1.2
}
const heights = {
  large: 48,
  medium: 36,
  default: 36,
  small: 32
}
const minWidths = {
  large: 128,
  medium: 96,
  default: 96,
  small: 96
}
const types = {
  default: `
    &&.ant-btn,
    &.ant-btn-clicked::after {
      border-color: ${Colors.paleGrey};
    }
    &&.ant-btn,
    &.ant-btn:focus {
      color: ${Colors.greyishBrown};
    }
    &.ant-btn:hover {
      color: ${Colors.pinkishGrey};
    }
    &.ant-btn:active {
      color: ${Colors.menu};
      background-color: ${Colors.aliceBlue};
    }
  `,
  primary: `
    &&.ant-btn {
      color: ${Colors.white};
      background-color: ${Colors.nvPriRed};
      border-color: ${Colors.nvPriRed};
    }
    &.ant-btn:hover {
      background-color: ${Colors.salmon};
      border-color: ${Colors.salmon};
    }
    &.ant-btn:active {
      background-color: ${Colors.nvDarkRed};
      border-color: ${Colors.nvDarkRed};
    }
    &.ant-btn-clicked::after {
      border-color: ${Colors.solitude};
    }
  `,
  secondary: `
    &&.ant-btn {
      color: ${Colors.white};
      background-color: ${Colors.greyishBrown};
      border-color: ${Colors.greyishBrown};
    }
    &.ant-btn:hover {
      background-color: ${Colors.warmGrey};
      border-color: ${Colors.warmGrey};
    }
    &.ant-btn:active {
      background-color: ${Colors.menu};
      border-color: ${Colors.menu};
    }
    &.ant-btn-clicked::after {
      border-color: ${Colors.greyishBrown};
    }
  `
}

// Do not pass size to AntButton since we have different size enums
// This is done to avoid warning in dev console
const StyledButton = styled(({ size, ...rest }) => <AntButton {...rest} />)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    border-radius: 3px;
    padding: 0 16px;
    letter-spacing: ${props => sizes[props.size]}px;
    font-size: ${props => fontSizes[props.size]}px;
    height: ${props => heights[props.size]}px;
    flex-basis: ${props => props.flexBasis || 'auto'};
    min-width: ${props => minWidths[props.size]}px;
  }
  ${props => types[props.type]};
  ${props =>
    props.disabled &&
    `
    &&.ant-btn[disabled] {
      color: ${Colors.pinkishGrey};
      background-color: ${Colors.whiteFour};
      border-color: ${Colors.whiteFour};
    }
  `};
`

const Button = props => <StyledButton {...props} />

Button.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['default', 'primary', 'secondary']),
  size: PropTypes.oneOf(['large', 'medium', 'default', 'small']),
  loading: PropTypes.bool,
  disabled: PropTypes.bool
}

Button.defaultProps = {
  children: 'Button',
  type: 'default',
  size: 'medium',
  loading: false,
  disabled: false
}

export default Button
